import { Vue } from 'vue-property-decorator';
import loader from '../../../utils/loader';
import store from '../../../store';
import corporateService from '../../../services/corporate';
import corporateTransformer from '../../../transformers/corporate';
import formMixin from '../../../Mixins/form';
import dateUtil from '../../../utils/dateTime';
import moment from 'moment';
import axios from 'axios';
import Contracts from './Contracts.vue';
import Transactions from './Transactions.vue';
import Profile from './Profile.vue';
import Employees from './Employees.vue';
import Admin from './Admin.vue';
import Package from './Package.vue';

export default Vue.extend({
  store,
  mixins: [formMixin],
  provide() {
    return { parentValidator: this.$validator };
  },
  data() {
    return {
      activeTab: 0, // first tab (Package) is selected by default on page load.
      loading: false,
      loadingEmployee: false,
      loadingAdmin: false,
      validForm: false,
      corporate: null,
      search: '',
      corporateList: null,
      extensionBar: false,
      allPackageList: [],
      allTags: [],
      banner: null,
      admins: [],
      empolyees: [],
      categoryChoices: {},
      selectedEmployee: null,
      addEmployeeModal: false,
      totalPages: 0,
      corporateHeader: [
        {
          text: 'Name',
          align: 'center',
          value: 'name',
          sortable: true,
        },
      ],
      employeeHeader: [
        {
          text: 'User Id',
          align: 'center',
          value: 'user_id',
          sortable: true,
        },
        {
          text: 'Email',
          align: 'center',
          value: 'email',
          sortable: true,
        },
        {
          text: 'Category 1',
          align: 'center',
          value: 'category1',
          sortable: true,
        },
        {
          text: 'Category 2',
          align: 'center',
          value: 'category2',
          sortable: true,
        },
        {
          text: 'Category 3',
          align: 'center',
          value: 'category3',
          sortable: true,
        },
        {
          text: 'Category 4',
          align: 'center',
          value: 'category4',
          sortable: true,
        },
        {
          text: 'Quota',
          align: 'center',
          value: 'quota',
          sortable: true,
        },
        {
          text: 'Quota Per Head',
          align: 'center',
          value: 'quota_per_head',
          sortable: false,
        },
        {
          text: 'Refresh Quota',
          align: 'center',
          value: 'refresh_quota',
          sortable: false,
        },
        {
          text: 'Active',
          align: 'center',
          value: 'active',
          sortable: true,
        },
        {
          text: 'Created At',
          align: 'center',
          value: 'created',
          sortable: true,
        },
        {
          text: 'Action',
          align: 'center',
          value: 'id',
          sortable: false,
        },
      ],
      filter: {
        page: 1,
        itemsPerPage: 10,
        search: null,
      },
      packageTypes: [
        {
          text: 'Time (Bundle)',
          value: 'time',
        },
        {
          text: 'Free (PPU)',
          value: 'free',
          disabled: true,
        },
        {
          text: 'Donation (WoS)',
          value: 'donation',
          disabled: true,
        },
      ],
      packageSizes: [
        {
          text: 'Small (S)',
          value: 'S',
        },
        {
          text: 'Medium (M)',
          value: 'M',
        },
        {
          text: 'Large (L)',
          value: 'L',
        },
        {
          text: 'Pay Per Use (PPU)',
          value: 'PPU',
          disabled: true,
        },
      ],
      packageTiers: [
        {
          text: 'Professional Psychologist',
          value: 'professional_psychologist',
        },
        {
          text: 'Deluxe Psychologist',
          value: 'deluxe_psychologist',
        },
        {
          text: 'Premium Psychologist',
          value: 'premium_psychologist',
        },
        {
          text: 'Professional Mix',
          value: 'professional_mix',
        },
        {
          text: 'Deluxe Mix',
          value: 'deluxe_mix',
        },
        {
          text: 'Premium Mix',
          value: 'premium_mix',
        },
      ],
      saleAdminList: [],
    };
  },
  computed: {
    dateUtil() {
      return dateUtil;
    },
    avatar() {
      return this.corporate.images ? this.corporate.images.banner : null;
    },
    package_start() {
      return this.corporate ? dateUtil.formatDate(this.corporate.package_start) : null;
    },
    expire() {
      return this.corporate ? dateUtil.formatDate(this.corporate.expire) : null;
    },
    package_start_time() {
      return this.corporate ? this.corporate.package_start_time : null;
    },
    expire_time() {
      return this.corporate ? this.corporate.expire_time : null;
    },
    corporateId() {
      return this.$route.params.id;
    },
    parentCorporate() {
      let parentCorporate = [{ text: 'None (top-level organisation)', value: null }];
      if (this.corporateList) {
        this.corporateList.forEach((element) => {
          if (!element.parent_organization && element.id !== this.corporateId)
            parentCorporate.push({
              text: element.name,
              value: element.id,
            });
        });
      }
      return parentCorporate;
    },
  },
  watch: {
    corporateId() {
      this.setup();
      this.resetFormError(null);
    },
    addEmployeeModal(val) {
      if (!val) {
        this.selectedEmployee = null;
      }
    },
    package_start(val, old) {
      if (old) {
        if (!moment().isSame(this.corporate.package_start, 'day')) {
          this.corporate.package_start_time = this.startOfDay;
        } else {
          this.corporate.package_start_time = this.minTime;
        }
      }
    },
    expire(val, old) {
      if (old) {
        if (!moment().isSame(this.corporate.expire, 'day')) {
          this.corporate.expire_time = this.startOfDay;
        } else {
          this.corporate.expire_time = this.minTime;
        }
      }
    },
  },
  created() {
    this.setup();
    this.getCorporateListForChoose();
    this.fetchAllCorporateCategoryChoices();
  },
  mounted() {},
  methods: {
    setup() {
      this.fetchAllTags();
      this.fetchCorporateProfile().then(() => {
        Promise.all([
          this.fetchSearchEmployee().then((data) => {
            this.empolyees = data.items;
            this.totalEmployee = data.total;
            this.totalPages = data.totalPages;
          }),
          this.fetchAllAdmin(),
          this.fetchSaleAdminList(),
        ]);
      });
    },
    getCorporateListForChoose() {
      corporateService
        .all()
        .then((data) => {
          this.corporateList = data.data;
        })
        .catch(() => {});
    },
    uploadAvatar(image) {
      const formData = new FormData();
      formData.append('banner', image.imageFile);
      corporateService
        .uploadBanner(this.corporateId, formData)
        .then(() => {
          this.fetchCorporateProfile;
          this.$notify({
            title: 'Update',
            text: 'Update Profile Avatar success !!',
            type: 'success',
          });
        })
        .catch(() => {});
    },
    fetchAllTags() {
      return corporateService
        .fetchTags()
        .then((response) => {
          this.allTags = response.data || [];
        })
        .catch((err) => {
          console.error('[CorporateProfiles] fetchAllTags failed:', err);
        });
    },
    fetchCorporateProfile() {
      return new Promise((resolve, reject) => {
        corporateService
          .fetch(this.corporateId)
          .then((data) => {
            this.corporate = data;
            this.allPackageList = [{ ...this.corporate }];
            resolve(true);
          })
          .catch((err) => {
            if (err.response.status === 404) {
              window.router.push({ name: 'notFound' });
            }
            reject(err);
          });
      });
    },
    fetchAllAdmin() {
      this.loadingAdmin = true;
      corporateService
        .fetchAllAdmin(this.corporateId)
        .then((data) => {
          this.loadingAdmin = false;
          this.admins = data;
        })
        .catch(() => {
          this.loadingAdmin = false;
        });
    },
    refetchEmployee() {
      this.fetchSearchEmployee().then((data) => {
        this.empolyees = data.items;
        this.totalEmployee = data.total;
        this.totalPages = data.totalPages;
      });
    },
    fetchAllCorporateCategoryChoices() {
      corporateService
        .fetchCorporateCategoryChoices(this.corporateId)
        .then((data) => {
          this.categoryChoices = data;
        })
        .catch((e) => {
          console.log('fetchAllCorporateCategoryChoices', e);
        });
    },
    fetchSaleAdminList() {
      corporateService.fetchAdminList().then((result) => {
        this.saleAdminList = result;
      });
    },
    fetchSearchEmployee() {
      this.loadingEmployee = true;
      return new Promise((resolve, reject) => {
        let query = {};
        query.per_page = this.filter.itemsPerPage;
        query.page = this.filter.page;
        if (this.filter.search) query.q = this.filter.search;
        corporateService
          .fetchSearchEmployee(this.corporateId, query)
          .then((data) => {
            this.loadingEmployee = false;
            let items = data.data;
            const meta = data.meta;
            const total = meta.pagination.total;
            const totalPages = meta.pagination.last_page;
            resolve({
              items,
              total,
              totalPages,
            });
          })
          .catch((err) => {
            this.loadingEmployee = false;
            reject(err);
          });
      });
    },
    onEmployeesFilterChange(filter) {
      this.filter = filter;
      this.fetchSearchEmployee().then((data) => {
        this.empolyees = data.items;
        this.totalPages = data.totalPages;
      });
    },
    deleteEmployee({ employee, reason }) {
      corporateService
        .deleteEmployee(employee.id, reason)
        .then(() => {
          this.empolyees = window._.reject(this.empolyees, {
            id: employee.id,
          });
          this.$notify({
            title: 'Delete',
            text: `Delete ${employee.email} success !!`,
            type: 'success',
          });
        })
        .catch(() => {});
    },
    addAdmin(formAdmin) {
      this.$root
        .$confirm('Add Admin', `Are you sure for add admin <b>${formAdmin.user}</b> ?`, {
          color: 'primary',
        })
        .then((confirm) => {
          if (confirm) {
            corporateService
              .addAdmin(this.corporateId, formAdmin)
              .then(() => {
                this.$notify({
                  title: 'Add',
                  text: 'Add Admin success !!',
                  type: 'success',
                });
                this.fetchAllAdmin();
                if (this.$refs.adminTab) {
                  this.$refs.adminTab.resetForm();
                }
              })
              .catch(() => {});
          }
        });
    },
    updateProfile() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$root
            .$confirm('Update', `Are you sure for update <b>${this.corporate.name}</b> ?`, {
              color: 'primary',
            })
            .then((confirm) => {
              if (confirm) {
                this.loading = true;
                corporateService
                  .edit(this.corporateId, corporateTransformer.send(this.corporate))
                  .then(() => {
                    this.$notify({
                      title: 'Update',
                      text: 'Update Profile success !!',
                      type: 'success',
                    });
                    this.loading = false;
                  })
                  .catch(() => {
                    this.loading = false;
                  });
              }
            });
        }
      });
    },
    toggleUpdateProfile() {
      this.loading = true;
      corporateService
        .edit(this.corporateId, corporateTransformer.sendToggle(this.corporate))
        .then(() => {
          this.$notify({
            title: 'Update',
            text: 'Update Profile success !!',
            type: 'success',
          });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    toggleStatusFromPackage() {
      // Pass 9a — Package card action.
      // Flip corporate.active locally, then reuse the same toggleUpdateProfile() flow as the Profile tab.
      this.corporate.active = !this.corporate.active;
      this.toggleUpdateProfile();
    },
    onAdjustSubmit(payload) {
      // Pass 9b — POST /organizations/:id/transactions
      // Payload from child: { amount: number (minutes, signed), description: string, type: string }
      const orgName = this.corporate.name || 'this organisation';
      const sessions = Math.abs(payload.amount / 30);
      const verb = payload.amount >= 0 ? 'add' : 'subtract';

      this.$root
        .$confirm(
          'Adjust Sessions',
          `Are you sure you want to ${verb} <b>${sessions} sessions</b> on <b>${orgName}</b>?<br/><br/>Reason: ${payload.description}`,
          { color: payload.amount >= 0 ? 'success' : 'error' }
        )
        .then((confirm) => {
          if (!confirm) return;

          this.$refs.packageTab.adjustSubmitting = true;
          axios
            .post(`/organizations/${this.corporateId}/transactions`, {
              amount: payload.amount,
              type: payload.type,
              description: payload.description,
              associated_type: payload.associatedType,
            })
            .then(() => {
              this.$notify({
                title: 'Success',
                text: `Adjustment recorded.`,
                type: 'success',
              });
              this.$refs.packageTab.closeAdjustModal();
              this.$refs.packageTab.adjustSubmitting = false;
              // Refresh corporate to show new wallet balance; transactions array will also refresh.
              this.fetchCorporateProfile();
            })
            .catch((error) => {
              this.$refs.packageTab.adjustSubmitting = false;
              const message =
                (error && error.response && error.response.data && error.response.data.message) ||
                'Failed to record adjustment.';
              this.$notify({
                title: 'Error',
                text: message,
                type: 'error',
              });
            });
        });
    },
    onContractSubmit(payload) {
      // Pass 9c — POST /organizations/:id/contracts
      // Three sub-cases for Bundle: renew_bundle_contract, extend_bundle_without_contract, correction.
      // PPU and switch-direction branches in Pass 9d.
      const orgName = this.corporate.name || 'this organisation';
      const sessionsAfter = Math.floor((payload.wallet_time || 0) / 30);
      const operationLabel =
        {
          renew_bundle_contract: 'add sessions with a signed contract',
          extend_bundle_without_contract: 'add sessions without a signed contract',
          correction: 'file a corrected contract that supersedes the previous one',
        }[payload.internal_note] || 'submit this contract';

      this.$root
        .$confirm(
          'File Contract or Extension',
          `Are you sure you want to ${operationLabel} on <b>${orgName}</b>?<br/><br/>Wallet after: <b>${sessionsAfter} sessions</b>.<br/>Reason: ${payload.contract_description}`,
          { color: payload.internal_note === 'correction' ? 'error' : 'primary' }
        )
        .then((confirm) => {
          if (!confirm) return;

          this.$refs.packageTab.contractSubmitting = true;
          axios
            .post(`/organizations/${this.corporateId}/contracts`, payload)
            .then(() => {
              this.$notify({
                title: 'Success',
                text: `Contract filed.`,
                type: 'success',
              });
              this.$refs.packageTab.closeContractModal();
              this.$refs.packageTab.contractSubmitting = false;
              this.fetchCorporateProfile();
            })
            .catch((error) => {
              this.$refs.packageTab.contractSubmitting = false;
              const message =
                (error && error.response && error.response.data && error.response.data.message) ||
                'Failed to file contract.';
              this.$notify({
                title: 'Error',
                text: message,
                type: 'error',
              });
            });
        });
    },
    // Formats any date value to YYYY-MM-DD HH:mm:ss for the backend contract validator
    toApiDateTime(val) {
      if (!val) return null;
      return moment(val).isValid() ? moment(val).format('YYYY-MM-DD HH:mm:ss') : null;
    },

    // Builds fields that must be carried unchanged into every contract POST
    getCarriedContractFields() {
      const lc = this.corporate.contracts && this.corporate.contracts[0];
      return {
        contract_name: (lc && lc.name) || this.corporate.package || 'Package contract',
        package_name: this.corporate.package || 'Package',
        package_type: this.corporate.package_type,
        package_size: (lc && lc.packageSize) || 'S',
        package_tier: (lc && lc.packageTier) || 'not_applicable',
        wallet_time: this.corporate.wallet_time,
        max_wallet_time: this.corporate.max_wallet_time,
        quota_per_head: this.corporate.quota_per_head,
        refresh_quota: this.corporate.refresh_quota,
        actual_start_at: this.toApiDateTime(this.corporate.package_start),
        actual_end_at: this.toApiDateTime(this.corporate.expire),
        contract_start_at: this.toApiDateTime(this.corporate.package_start),
        contract_end_at: this.toApiDateTime(this.corporate.expire),
      };
    },

    // Handles @expiry-submit: POSTs a contract row to update the organisation's expiry date
    onExpirySubmit(payload) {
      // Guard: reject if expiry is on or before start date
      if (this.minExpiryDate && payload.expiry_date <= this.minExpiryDate) return;
      const newEndAt = this.toApiDateTime(payload.expiry_date);
      const note = this.corporate.package_type === 'time' ? 'renew_bundle_contract' : 'renew_ppu_contract';

      this.$refs.packageTab.expirySubmitting = true;
      axios
        .post(`/organizations/${this.corporateId}/contracts`, {
          ...this.getCarriedContractFields(),
          contract_description: `Expiry changed to ${payload.expiry_date}`,
          internal_note: note,
          actual_end_at: newEndAt,
          contract_end_at: newEndAt,
        })
        .then(() => {
          this.$notify({ title: 'Success', text: 'Expiry updated.', type: 'success' });
          this.$refs.packageTab.expiryModalOpen = false;
          this.$refs.packageTab.expiryDraftDate = '';
          this.$refs.packageTab.expirySubmitting = false;
          this.fetchCorporateProfile();
        })
        .catch((error) => {
          this.$refs.packageTab.expirySubmitting = false;
          const message =
            (error && error.response && error.response.data && error.response.data.message) ||
            'Failed to update expiry.';
          this.$notify({ title: 'Error', text: message, type: 'error' });
        });
    },

    // Handles @sessions-used-submit: POSTs a transaction row to adjust the wallet balance
    onSessionsUsedSubmit(payload) {
      this.$refs.packageTab.donutSubmitting = true;
      axios
        .post(`/organizations/${this.corporateId}/transactions`, {
          amount: payload.amount,
          type: payload.type,
          description: payload.description,
          associated_type: payload.associated_type,
        })
        .then(() => {
          this.$notify({ title: 'Success', text: 'Sessions updated.', type: 'success' });
          this.$refs.packageTab.onDonutEditCancel();
          this.$refs.packageTab.donutSubmitting = false;
          this.fetchCorporateProfile();
        })
        .catch((error) => {
          this.$refs.packageTab.donutSubmitting = false;
          const message =
            (error && error.response && error.response.data && error.response.data.message) ||
            'Failed to update sessions.';
          this.$notify({ title: 'Error', text: message, type: 'error' });
        });
    },

    // Handles @max-sessions-submit: POSTs a correction contract to raise or lower the session ceiling
    onMaxSessionsSubmit(payload) {
      this.$refs.packageTab.donutSubmitting = true;
      axios
        .post(`/organizations/${this.corporateId}/contracts`, {
          ...this.getCarriedContractFields(),
          contract_description: `Max sessions adjusted to ${Math.floor(payload.new_max_wallet_time / 30)}`,
          internal_note: 'correction',
          wallet_time: payload.new_wallet_time,
          max_wallet_time: payload.new_max_wallet_time,
        })
        .then(() => {
          this.$notify({ title: 'Success', text: 'Max sessions updated.', type: 'success' });
          this.$refs.packageTab.onDonutEditCancel();
          this.$refs.packageTab.donutSubmitting = false;
          this.fetchCorporateProfile();
        })
        .catch((error) => {
          this.$refs.packageTab.donutSubmitting = false;
          const message =
            (error && error.response && error.response.data && error.response.data.message) ||
            'Failed to update max sessions.';
          this.$notify({ title: 'Error', text: message, type: 'error' });
        });
    },

    // Handles @refresh-rate-change: PATCHes the organisation's quota refresh rate immediately
    onRefreshRateChange(payload) {
      axios
        .patch(`/organizations/${this.corporateId}`, { refresh_quota: payload.refresh_quota })
        .then(() => {
          this.$notify({ title: 'Success', text: 'Refresh rate updated.', type: 'success' });
          this.fetchCorporateProfile();
        })
        .catch((error) => {
          const message =
            (error && error.response && error.response.data && error.response.data.message) ||
            'Failed to update refresh rate.';
          this.$notify({ title: 'Error', text: message, type: 'error' });
        });
    },

    // Handles @quota-submit: PATCHes quota_per_head (value is already in minutes from Package.js)
    onQuotaSubmit(payload) {
      this.$refs.packageTab.fieldSubmitting = true;
      axios
        .patch(`/organizations/${this.corporateId}`, { quota_per_head: payload.quota_per_head })
        .then(() => {
          this.$notify({ title: 'Success', text: 'Quota updated.', type: 'success' });
          this.$refs.packageTab.onFieldEditCancel();
          this.$refs.packageTab.fieldSubmitting = false;
          this.fetchCorporateProfile();
        })
        .catch((error) => {
          this.$refs.packageTab.fieldSubmitting = false;
          const message =
            (error && error.response && error.response.data && error.response.data.message) ||
            'Failed to update quota.';
          this.$notify({ title: 'Error', text: message, type: 'error' });
        });
    },

    // Handles @user-cap-submit: PATCHes the maximum number of employees allowed
    onUserCapSubmit(payload) {
      this.$refs.packageTab.fieldSubmitting = true;
      axios
        .patch(`/organizations/${this.corporateId}`, { user_cap: payload.user_cap })
        .then(() => {
          this.$notify({ title: 'Success', text: 'User cap updated.', type: 'success' });
          this.$refs.packageTab.onFieldEditCancel();
          this.$refs.packageTab.fieldSubmitting = false;
          this.fetchCorporateProfile();
        })
        .catch((error) => {
          this.$refs.packageTab.fieldSubmitting = false;
          const message =
            (error && error.response && error.response.data && error.response.data.message) ||
            'Failed to update user cap.';
          this.$notify({ title: 'Error', text: message, type: 'error' });
        });
    },

    // Handles @package-submit: saves the package name only, touching no other field
    onPackageSubmit(payload) {
      this.$refs.packageTab.fieldSubmitting = true;
      axios
        // Body carries the package name alone so nothing else can be overwritten
        .patch(`/organizations/${this.corporateId}`, { package: payload.package })
        .then(() => {
          this.$notify({ title: 'Success', text: 'Package name updated.', type: 'success' });
          this.$refs.packageTab.onFieldEditCancel();
          this.$refs.packageTab.fieldSubmitting = false;
          // Refetch keeps the local copy fresh so a later save cannot resend the old name
          this.fetchCorporateProfile();
        })
        .catch((error) => {
          this.$refs.packageTab.fieldSubmitting = false;
          const message =
            (error && error.response && error.response.data && error.response.data.message) ||
            'Failed to update package name.';
          this.$notify({ title: 'Error', text: message, type: 'error' });
        });
    },

    // Handles @switch-type-submit: POSTs a contract to switch Bundle↔PPU; drains wallet if Bundle→PPU
    onSwitchTypeSubmit(payload) {
      const newType = payload.new_package_type;
      const newWalletTime = newType === 'time' ? payload.sessions * 30 : null;
      const newExpiry = this.toApiDateTime(payload.expiry_date);
      const note = newType === 'free' ? 'switch_bundle_to_ppu' : 'switch_ppu_to_bundle';

      this.$refs.packageTab.switchTypeSubmitting = true;
      axios
        .post(`/organizations/${this.corporateId}/contracts`, {
          ...this.getCarriedContractFields(),
          contract_description: `Package type changed to ${newType === 'time' ? 'Bundle' : 'PPU'}`,
          internal_note: note,
          package_type: newType,
          package_size: newType === 'free' ? 'PPU' : 'S',
          package_tier: 'not_applicable',
          wallet_time: newWalletTime,
          max_wallet_time: newWalletTime,
          quota_per_head: payload.quota_per_head,
          refresh_quota: payload.refresh_quota,
          actual_end_at: newExpiry,
          contract_end_at: newExpiry,
        })
        .then(() => {
          // Bundle → PPU: post a drain transaction if there was a remaining wallet balance
          if (newType === 'free' && payload.old_wallet_time > 0) {
            return axios.post(`/organizations/${this.corporateId}/transactions`, {
              amount: -payload.old_wallet_time,
              type: 'time',
              description: `Wallet drained on switch to PPU — ${Math.floor(
                payload.old_wallet_time / 30
              )} sessions removed`,
              associated_type: 'switch_bundle_to_ppu',
            });
          }
        })
        .then(() => {
          this.$notify({ title: 'Success', text: 'Package type switched.', type: 'success' });
          this.$refs.packageTab.switchTypeModalOpen = false;
          this.$refs.packageTab.switchTypeSubmitting = false;
          this.fetchCorporateProfile();
        })
        .catch((error) => {
          this.$refs.packageTab.switchTypeSubmitting = false;
          const message =
            (error && error.response && error.response.data && error.response.data.message) ||
            'Failed to switch package type.';
          this.$notify({ title: 'Error', text: message, type: 'error' });
        });
    },

    // Handles @tag-save: PATCHes tag_ids; backend does DELETE all + INSERT new tag_organizations rows
    onTagSave(payload) {
      this.$refs.packageTab.tagSubmitting = true;
      axios
        .patch(`/organizations/${this.corporateId}`, { tag_ids: payload.tag_ids })
        .then(() => {
          this.$notify({ title: 'Success', text: 'Tags updated.', type: 'success' });
          this.$refs.packageTab.cancelTagEdit();
          this.$refs.packageTab.tagSubmitting = false;
          this.fetchCorporateProfile();
        })
        .catch((error) => {
          this.$refs.packageTab.tagSubmitting = false;
          const message =
            (error && error.response && error.response.data && error.response.data.message) || 'Failed to update tags.';
          this.$notify({ title: 'Error', text: message, type: 'error' });
        });
    },
    editEmployee(one = null) {
      if (one) this.selectedEmployee = one;
      this.addEmployeeModal = true;
    },
    viewCorporate(id) {
      window.router.push({
        name: 'corporateProfile',
        params: {
          id: id,
        },
      });
    },
    celi(val) {
      return Math.ceil(val);
    },
  },
  components: {
    AddEmployee: loader.component('AddEmployee'),
    UploadEmployee: loader.component('UploadEmployee'),
    UploadAvatar: loader.component('UploadAvatar'),
    Contracts,
    Transactions,
    Profile,
    Employees,
    Admin,
    Package,
  },
});
